import Card from "@material-tailwind/react/Card";
import CardHeader from "@material-tailwind/react/CardHeader";
import CardBody from "@material-tailwind/react/CardBody";
import InputIcon from "@material-tailwind/react/InputIcon";
import DataTable from "react-data-table-component";
import { Label, Button } from "@material-tailwind/react";
// import { IconButton } from "@material-tailwind/react";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
export default function CardTable({ playerMutation, pending, usernameEvent, fromCreateAtEvent, toCreateAtEvent, onChangeRowsPerPage }) {
  const columns = [
    {
      name: "Username",
      selector: (row) => row.user,
      sortable: true,
      width: "150px",
    },
    {
      name: "Description",
      selector: (row) => row.desc,
      sortable: true,
      wrap: true,
    },
    {
      name: "Ref ID",
      selector: (row) => row.ref,
      wrap: true,
      sortable: true,
      width: "250px",
    },
    {
      name: "Amount",
      selector: (row) => <tt>{row.amnt}</tt>,
      sortable: true,
      right: true,
    },
    {
      name: "Balance Before",
      selector: (row) => <tt>{row.bbal}</tt>,
      sortable: true,
      right: true,
    },
    {
      name: "Balance After",
      selector: (row) => <tt>{row.nbal}</tt>,
      sortable: true,
      right: true,
    },
  ];


  return (
    <>
      <Card>
        <h5>Advanced Search</h5>
        <CardBody>
          <div className="flex gap-4">
            <InputIcon
              type="text"
              color="lightBlue"
              size="sm"
              outline={true}
              placeholder="Username"
              iconName="search"
              onChange={usernameEvent}
            />
          </div>
          <div className="flex mt-4">
            <div style={{ width: '100%', display: 'flex', gap: '10px', flexDirection: "column", border: '1px solid #DCDCDC', borderRadius: '10px', padding: '20px' }}>
              <p>Created Date</p>
              <InputIcon
                type="date"
                color="lightBlue"
                size="sm"
                outline={true}
                placeholder="From"
                iconName=""
                onChange={fromCreateAtEvent}
              />
              <InputIcon
                type="date"
                color="lightBlue"
                size="sm"
                outline={true}
                placeholder="To"
                iconName=""
                onChange={toCreateAtEvent}
              />
            </div>
          </div>
        </CardBody>
      </Card>
      <Card className="mt-12">
        <CardHeader color="blueGray" contentPosition="left">
          <h2 className="text-white text-2xl">Player Mutation</h2>
        </CardHeader>
        <CardBody>
          <DataTable
            columns={columns}
            data={playerMutation}
            progressPending={pending}
            onChangeRowsPerPage={onChangeRowsPerPage}
            paginationRowsPerPageOptions={[10, 50, 100, 500]}
            pagination
          />
        </CardBody>
      </Card>
    </>
  );
}
